import { useFeatureFlags } from 'common/hooks';
import useUser from 'common/hooks/useUser';

const featureFlagName = 'merchant_dac_7_report_download_button';

export const useIsDac7ReportEnabled = ({
  merchantId,
  merchantCountry,
}: {
  merchantId: string;
  merchantCountry: Country;
}) => {
  const { user, isEmployee } = useUser();

  const { data: featureFlags } = useFeatureFlags([featureFlagName], {
    user_id: user?.id || '',
    user_email: user?.email || '',
    user_country: user?.country || '',
    is_employee: isEmployee,
    merchant_id: merchantId,
    merchant_country: merchantCountry,
  });

  return featureFlags?.[featureFlagName] === 'on' || false;
};
